import type {AxiosError} from 'axios';
import {useQuery} from '@tanstack/react-query';
import {getObjectionStatus} from '@/api/help/objection';
import {
  ApiErrorResponse,
  ObjectionStatusResponse,
  ObjectionUserData,
} from '@/api/help/objection/type';

/**
 * 이의제기 상태를 조회
 * @returns {ObjectionUserData | null} data - 이의제기 상태 데이터
 */
export const useGetObjectionStatus = () => {
  return useQuery<
    ObjectionStatusResponse,
    AxiosError<ApiErrorResponse>,
    ObjectionUserData | null
  >({
    queryKey: ['objectionStatus'],
    queryFn: getObjectionStatus,
    select: (response) => {
      if (!response || typeof response.message !== 'string') {
        return null;
      }
      return response.message === 'success' ? response.data : null;
    },
    retry: false,
  });
};
